import { AutonomousSystemsCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {AutonomousSystemsCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) =>
  data?.autonomousSystemsAggregate.aggregate?.count;
